export const excludeSearchParams = (relativeUrl: string, searchParamNames: string[]): string => {
  const url = new URL(relativeUrl, location.origin);

  for (const name of searchParamNames) {
    url.searchParams.delete(name);
  }

  return `${url.pathname}${url.search}`;
};
